import { trackEvent } from '../util/analytics'

up.compiler('[track-page-view]', { priority: -50 }, ($element, data) => {
  // We use a [track-page-view] element that is rendered on every request to
  // allow tracking when page contents are updated through Unpoly.
  // URL data is sent from the server as `up-data`.
  let eventData = Object.assign({}, data, {
    page: {
      title: document.title,
      modal: up.layer.isOverlay(),
    },
  })

  trackEvent('page.view', eventData)
})
